import { FETCH_ADS } from "../../actions/dcm/constants";
import { SUCCESS, FAILURE, PENDING } from "../../actions/constants";

import { normalizeDataByField } from "../utils/normalize";

const initialState = {
  isLoading: false,
  byId: {},
  allIds: [],
  adsByPlacementId: {}
};

export const dcmAds = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADS:
      switch (action.status) {
        case SUCCESS:
          let { byId, allIds } = normalizeDataByField(action.data, "id");
          let adsByPlacementId = normalizeByPlacementId(action.data);

          return { isLoading: false, byId, allIds, adsByPlacementId };
        case FAILURE:
          return {
            isLoading: false,
            byId: { ...state.byId },
            allIds: [...state.allIds],
            adsByPlacementId: { ...state.adsByPlacementId }
          };
        case PENDING:
          return {
            isLoading: true,
            byId: { ...state.byId },
            allIds: [...state.allIds],
            adsByPlacementId: { ...state.adsByPlacementId }
          };
        default:
          return state;
      }
    default:
      return state;
  }
};

const normalizeByPlacementId = adData => {
  let adsByPlacementId = {};

  adData.map(ad => {
    ad.placementAssignments.map(placement => {
      if (adsByPlacementId[placement.placementId]) {
        adsByPlacementId[placement.placementId].push(ad);
      } else {
        adsByPlacementId[placement.placementId] = [ad];
      }
      return null;
    });
    return null;
  });

  return adsByPlacementId;
};
